import { render, staticRenderFns } from "./IncidentHistory.vue?vue&type=template&id=270006f0&"
import script from "./IncidentHistory.vue?vue&type=script&lang=js&"
export * from "./IncidentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports